import dayjs from 'dayjs'
import {SurgeryRequestItem} from '../types/surgeryRequests'

type ValidateSurgeryRequestConflictsProps = {
  item: SurgeryRequestItem
  list: SurgeryRequestItem[]
}

export type SurgeryRequestConflictResult = {
  roomConflict: boolean
  conflictedStaffIds: string[]
}

export const validateSurgeryRequestConflicts = (
  props: ValidateSurgeryRequestConflictsProps,
): SurgeryRequestConflictResult | undefined => {
  const {item, list} = props
  const currentItemId = item.$id ?? null
  const operationTime = dayjs(item.operationTime)

  const currentStaffIds = [
    ...(item.surgeon ?? []),
    ...(item.assistant ?? []),
    ...(item.anesthesiologist ?? []),
    ...(item.anesthesiaNurse ?? []),
    ...(item.scrubNurse ?? []),
  ]
  const result = list.reduce<SurgeryRequestConflictResult>(
    (acc, existingItem) => {
      if (existingItem.$id === currentItemId) {
        return acc
      }

      const isSameTime = dayjs(existingItem.operationTime).isSame(
        operationTime,
        'minute',
      )

      if (!isSameTime) {
        return acc
      }

      const currentOperationRoom = item.operationRoom as unknown as string
      const isSameRoom =
        currentOperationRoom === existingItem.operationRoom.$id

      if (isSameRoom) {
        acc.roomConflict = true
      }

      const existingStaffIds = [
        ...(existingItem.surgeon ?? []),
        ...(existingItem.assistant ?? []),
        ...(existingItem.anesthesiologist ?? []),
        ...(existingItem.anesthesiaNurse ?? []),
        ...(existingItem.scrubNurse ?? []),
      ]

      currentStaffIds.forEach((staffId) => {
        if (existingStaffIds.includes(staffId)) {
          acc.conflictedStaffIds.push(staffId)
        }
      })

      return acc
    },
    {
      roomConflict: false,
      conflictedStaffIds: [],
    },
  )

  const uniqueConflictedStaffIds = Array.from(
    new Set(result.conflictedStaffIds),
  )

  if (!result.roomConflict && uniqueConflictedStaffIds.length === 0) {
    return undefined
  }

  return {
    roomConflict: result.roomConflict,
    conflictedStaffIds: uniqueConflictedStaffIds,
  }
}